import ClientBase from "../ClientBase";

const BASE_URL = "api/v1/inferencebatches";

class InferenceBatchClient extends ClientBase {

    // Every batch summary for a scan (one per project run), newest first.
    async getByScanId(scanId) {
        return await this.get(`${BASE_URL}/scans/${scanId}`) ?? [];
    }

    // The most recent batch summary for a scan (authoritative keyframe list + run header).
    async getLatest(scanId) {
        return await this.get(`${BASE_URL}/scans/${scanId}/latest`);
    }
}

export default new InferenceBatchClient();
